import Vue from 'vue'
import Router from 'vue-router'
import Landing from '@/components/landing/landing-component'
import Interlude from '@/components/landing-interlude/landing-interlude-component'
import Imprint from '@/components/imprint/imprint-component'
import Privacy from '@/components/privacy/privacy-component'
import Plan from '@/components/plan/plan-component'
import Overview from '@/components/overview/overview-component'
import Connect from '@/components/connect/connect-component'
import Install from '@/components/install/install-component'
import Language from '@/components/language/language-component'
import Test from '@/components/test/test-component'
import SuccessComponent from '@/components/success/success-component'

import store from '../store.js'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/landing/:id',
      name: 'landing',
      component: Landing
    },
    {
      path: '/interlude/:id',
      name: 'interlude',
      component: Interlude
    },
    {
      path: '/imprint/:id',
      name: 'imprint',
      component: Imprint
    },
    {
      path: '/privacy/:id',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/overview/:id',
      name: 'overview',
      component: Overview
    },
    {
      path: '/language/:id',
      name: 'language',
      component: Language
    },
    {
      path: '/plan/:id',
      name: 'plan',
      component: Plan
    },
    {
      path: '/connect/:id',
      name: 'connect',
      component: Connect
    },
    {
      path: '/install/:id',
      name: 'install',
      component: Install
    },
    {
      path: '/test/:id',
      name: 'test',
      component: Test
    },
    {
      path: '/success/:id',
      name: 'success',
      component: SuccessComponent
    },
    {
      path: '/',
      name: 'home',
      component: Landing
    }
  ],
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  const L_SUPPORTED = store.getters.languages
  if (to.path === '/' || L_SUPPORTED.indexOf(to.params.id) !== -1) {
    // PDF for languages
    switch (to.params.id) {
      case 'ee_EE':
        window.location = 'https://cdn.cloud.grohe.com/Literature/Brochures/et_EE/GROHE_SenseCheck_ET/original/GROHE_SenseCheck_ET.pdf?utm_medium=print&utm_source=qr_code&utm_campaign=ee_qr&utm_content=GROHE_Sense_Check#_ga=2.133996558.12864105.1541610910-1955883958.1534254682&_gac=1.81198821.1538657774.Cj0KCQjw9NbdBRCwARIsAPLsnFb2JUAYd_20xBnOLU26E09rbtEfRLTHQmu2JgFvFGkxJnbhbmqAGNQaAlpdEALw_wcB'
        break
      case 'lv_LV':
        window.location = 'https://cdn.cloud.grohe.com/Literature/Brochures/lv_LV/GROHE_SenseCheck_LV/original/GROHE_SenseCheck_LV.pdf?utm_medium=print&utm_source=qr_code&utm_campaign=lv_qr&utm_content=GROHE_Sense_Check#_ga=2.133996558.12864105.1541610910-1955883958.1534254682&_gac=1.81198821.1538657774.Cj0KCQjw9NbdBRCwARIsAPLsnFb2JUAYd_20xBnOLU26E09rbtEfRLTHQmu2JgFvFGkxJnbhbmqAGNQaAlpdEALw_wcB'
        break
      case 'lt_LT':
        window.location = 'https://cdn.cloud.grohe.com/Literature/Brochures/lt_LT/GROHE_SenseCheck_LT/original/GROHE_SenseCheck_LT.pdf?utm_medium=print&utm_source=qr_code&utm_campaign=lt_qr&utm_content=GROHE_Sense_Check#_ga=2.133996558.12864105.1541610910-1955883958.1534254682&_gac=1.81198821.1538657774.Cj0KCQjw9NbdBRCwARIsAPLsnFb2JUAYd_20xBnOLU26E09rbtEfRLTHQmu2JgFvFGkxJnbhbmqAGNQaAlpdEALw_wcB'
        break
      default:
        next()
        break
    }
  } else {
    let lang = ((to.params.id) ? to.params.id : 'en_GB').substring(0, 2).toLocaleLowerCase()
    let originalPath = to.path
    let path = ''
    if (originalPath.lastIndexOf('/') !== 0) {
      path = (L_SUPPORTED.indexOf(lang) !== -1) ? originalPath.substring(0, originalPath.lastIndexOf('/') + 1) + lang : originalPath.substring(0, originalPath.lastIndexOf('/') + 1) + 'en_GB'
    } else {
      path = originalPath + '/' + lang
    }
    next({path: path})
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js